import { useFormik } from "formik";
import * as Yup from "yup";
import MyModal from "../Widgets/Modal";
import { Box } from "@mui/material";
import MyForm from "../Widgets/Form";
import InputTextField from "../Widgets/InputTextField";
import { useMutation } from "react-query";
import { addTab } from "../../services/tab";
import { useDispatch } from "react-redux";
import { tabActions } from "../../store/tab";

export const AddOngletModal = ({ isOpen, onClose }) => {

    const dispatch = useDispatch();
    const mutation = useMutation((params) => addTab(params), {
        onSuccess: (data) => {
            dispatch(tabActions.updateTabsConfig(data))
            formik.resetForm({
                values: {
                    name: "",
                }
            });
            onClose();
        },
        onError: () => { },
    });

    const formik = useFormik({
        initialValues: {
            name: "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Nom requis"),
        }),
        onSubmit: async () => {
            mutation.mutate(formik.values);
        },
    });

    return (
        <MyModal
            open={isOpen}
            displayButtons
            handleCancel={onClose}
            handleValidate={() => {
                formik.handleSubmit();
            }}
        >
            <Box minWidth="300px">
                <h2>Ajouter un onglet</h2>
                <MyForm onSubmit={formik.handleSubmit}>
                    <InputTextField formik={formik} formikItemKey="name" label="Nom" />
                </MyForm>
            </Box>
        </MyModal>
    );
}